@use '@/scss/underscore' as _;

.title {
  @include _.subhead-cap-small;
  color: var(--color-neutral-variant-70);
  padding: _.unit(2) _.unit(6);
}
